import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";


export default function ModalInfoKlimageschwindigkeitsbonus() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const heizung_future = useStore((state)=>state.heizung_future);

  return (<Panel >
            <h1>Was bedeutet Klimageschwindigkeits-Bonus?</h1>
            {heizung_future == "heating_system_planned_7" &&<p>Heizung wird ausgetauscht und die neue Heizung mit einer Solarthermieanlage, einer PV-Anlage oder Wärmepumpe zur Warmwasserbereitung und/oder Raumheizung kombiniert.</p>            }
            <p>Den Klimageschwindigkeits-Bonus gibt es nur für selbstnutzende Wohneigentümer, deren alte Gas- o. Biomasseheizung mind. 20 Jahre alt ist, o. die eine Öl-, Kohle-, Gasetagen- o. Nachtspeicherheizung besitzen. Nach der Heizungsmodernisierung wird nicht mehr mit fossilen Brennstoffen geheizt und die Entsorgung der alten Heizung nachgewiesen.</p>
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

